const DEFAULT_TEXTS = {
	reccomended: 'raccomandato',
};
export default DEFAULT_TEXTS;
